module.exports = __webpack_public_path__ + "static/media/adey-bennett-loop-1.7c23b17f.mp4";